<template>
  <div class="content-body">
    <component :is="curentComponents"
    :plan_data="plan_data"
    :group_data="group_data"
    :adv_data="adv_data"
     @showOther="showOther"
     @plan_call_back="plan_call_back"
     @jump_form_plan="jump_form_plan"
     @jump_form_group="jump_form_group"
     @jump_form_adv="jump_form_adv"

     ></component>
  </div>
</template>

<script>
// @ is an alias to /src
export default {
  /* global require */
  name: 'index',
  data() {
    return {
      curentComponents: 'PlanView',
      plan_data: [], // 修改数据时数据
      group_data: [], // 修改数据时数据
      adv_data: [] // 修改数据时数据
    };
  },
  created() {

  },
  methods: {
    showOther(type) {
      const views = {
        plan: 'PlanView',
        group: 'GroupView',
        adv: 'AdvView'
      };
      if (type !== '') {
        this.curentComponents = views[type];
      }
    },
    plan_call_back(type) {
      const views = {
        cancel: 'PlanView',
        next: 'CreateGroup',
        groupCancel: 'GroupView',
        groupNext: 'CreateAdv',
        advCancel: 'AdvView'
      };
      if (type !== '') {
        this.curentComponents = views[type];
      }
    },
    jump_form_plan(plan_data = []) {
      this.curentComponents = 'CreatePlan';
      this.plan_data = plan_data;
    },
    jump_form_group(group_data = []) {
      this.curentComponents = 'CreateGroup';
      this.group_data = group_data;
    },
    jump_form_adv(adv_data = []) {
      this.curentComponents = 'CreateAdv';
      this.adv_data = adv_data;
    }
  },
  components: {
    PlanView: resolve => require(['./Components/Plan.vue'], resolve),
    GroupView: resolve => require(['./Components/Group.vue'], resolve),
    AdvView: resolve => require(['./Components/Adv.vue'], resolve),
    CreatePlan: resolve => require(['./Components/create_plan.vue'], resolve),
    CreateGroup: resolve => require(['./Components/create_group.vue'], resolve),
    CreateAdv: resolve => require(['./Components/create_adv.vue'], resolve)
  }
};
</script>
<style lang="less" scoped="">

</style>
